export default __webpack_public_path__ + "static/media/Niceair.34a11f4e.svg";